import styled from "styled-components";

export const StyledSection5 = styled.div`
  .section5-container {
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    gap: 32px;
    padding-top: 32px;
  }
`;
